import './Components/BootstrapModal/bootstrap-modal';
import './Components/BootstrapCollapse/bootstrap-collapse';
import './Components/BootstrapDropdown/bootstrap-dropdown';

'use strict';

function init() {
	const callColibriUtil = ( fn, ...args ) => {
		window.colibri = window.colibri || {};
		window.colibri.utils = window.colibri.utils || {};
		const util = window.colibri.utils[ fn ];
		if ( typeof util === 'function' ) {
			util.apply( null, args );
			return;
		}
		window.colibri.utils._queue = window.colibri.utils._queue || [];
		window.colibri.utils._queue.push( { fn, args } );
	};

	window.colibri.gdprReady.then( function( isGdprVisitor ) {
		callColibriUtil( 'maybeUpdateTimezones' );
		callColibriUtil( 'maybeInitMapLinks' );

		document.querySelectorAll( '.js-disable-click' ).forEach( function( el ) {
			el.addEventListener( 'click', ( e ) => {
				e.preventDefault();
			} );
		} );

		/**
		 * Check if a user has scrolled to a products list to track on GA4.
		 */
		const courseLists = document.querySelectorAll( '[data-module="course-list"]' );

		if ( courseLists.length > 0 ) {
			courseLists.forEach( function( courseList ) {
				courseList.listViewed = false;
				let productCodes = [];

				// Get all the products in the list.
				const cards = courseList.querySelectorAll( '.card' );
				cards.forEach( function( card ) {
					const itemId = +card.getAttribute( 'data-item-id' );
					if ( isGdprVisitor && window.colibri.shouldHideForGdpr( itemId ) ) {
						const parent = card.parentElement;
						if ( parent && parent.classList.contains( 'grid-col' ) ) {
							parent.remove();
						} else {
							card.remove();
						}
					}

					const addToCartContainer = card.querySelector( '.add-to-cart-container' );
					const productCode = addToCartContainer
						? addToCartContainer.getAttribute( 'data-alt-product-code' ) ??
						  addToCartContainer.getAttribute( 'data-product-code' )
						: null;
					if ( productCode ) {
						productCodes.push( productCode );
					}
				} );

				courseList.productCodes = productCodes;
			} );

			window.addEventListener( 'scroll', checkIfProductsListInViewport );
			checkIfProductsListInViewport();

			const packagesTabs = document.querySelectorAll( '.wp-block-colibri-tabs__tab' );
			packagesTabs.forEach( function( packagesTab ) {
				packagesTab.addEventListener( 'click', function() {
					checkIfProductsListInViewport();
				} );
			} );

			function checkIfProductsListInViewport() {
				const viewportHeight = window.innerHeight;

				courseLists.forEach( function( courseList ) {
					if ( courseList.offsetParent ) {
						const courseListPosition = courseList.getBoundingClientRect().top;
						const scrollThreshold = courseListPosition - viewportHeight / 3;

						if (
							scrollThreshold <= 0 &&
							scrollThreshold > -courseList.offsetHeight + viewportHeight / 3
						) {
							if ( courseList.listViewed === false ) {
								callColibriUtil(
									'pushAnalyticsData',
									'list',
									'view_item_list',
									courseList.productCodes,
								);
								courseList.listViewed = true;
							}
						} else {
							courseList.listViewed = false;
						}
					}
				} );
			}
		}

		/**
		 * Check if a user is viewing a Product Details page to track on GA4.
		 */
		const body = document.body;
		if ( body.classList.contains( 'single-product' ) ) {
			const productCodeElement = document.querySelector( '[data-product-code]' );
			const productCode = productCodeElement.getAttribute( 'data-product-code' );
			callColibriUtil( 'pushAnalyticsData', productCode, 'view_item' );
		}

		/**
		 * Check if a user opened a View Product Details modal to track on GA4.
		 */
		const viewDetailsButtons = document.querySelectorAll( '.details-page-link[rel="modal"]' );
		viewDetailsButtons.forEach( function( viewDetailsButton ) {
			viewDetailsButton.addEventListener( 'click', onViewDetailsButtonClick );
		} );

		function onViewDetailsButtonClick( event ) {
			const target = event.target;
			if ( !( target instanceof Element ) ) {
				return;
			}
			const productCode = target.getAttribute( 'data-product-code' );
			callColibriUtil( 'pushAnalyticsData', productCode, 'view_item' );
		}
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
